'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uncontrollable = require('uncontrollable');

var _uncontrollable2 = _interopRequireDefault(_uncontrollable);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Col = require('../Col');

var _Col2 = _interopRequireDefault(_Col);

var _Nav = require('../Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = require('../NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _styleMaps = require('../utils/styleMaps');

var _styleMaps2 = _interopRequireDefault(_styleMaps);

var _isRequiredForA11y = require('react-prop-types/lib/isRequiredForA11y');

var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);

var _deprecationWarning = require('../utils/deprecationWarning');

var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);

var _ValidComponentChildren = require('../utils/ValidComponentChildren');

var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);

var _TabContainer = require('./TabContainer');

var _TabContainer2 = _interopRequireDefault(_TabContainer);

var _TabContent = require('./TabContent');

var _TabContent2 = _interopRequireDefault(_TabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TabContainer = _TabContainer2.default.ControlledComponent;

function getDefaultActiveKeyFromChildren(children) {
  var defaultActiveKey = void 0;
  _ValidComponentChildren2.default.forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this));

    _this.getActiveKey = _this.getActiveKey.bind(_this);
    _this.renderPane = _this.renderPane.bind(_this);
    _this.renderTab = _this.renderTab.bind(_this);
    _this.getColProps = _this.getColProps.bind(_this);
    return _this;
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          className = _props.className,
          style = _props.style,
          position = _props.position,
          tabWidth = _props.tabWidth,
          paneWidth = _props.paneWidth,
          standalone = _props.standalone,
          children = _props.children,
          onSelect = _props.onSelect,
          props = _objectWithoutProperties(_props, ['id', 'className', 'style', 'position', 'tabWidth', 'paneWidth', 'standalone', 'children', 'onSelect']);

      var _props2 = this.props,
          bsStyle = _props2.bsStyle,
          activeKey = _props2.activeKey;


      activeKey = this.getActiveKey();

      var isHorizontal = position === 'left' || position === 'right';

      if (bsStyle == null) {
        bsStyle = isHorizontal ? 'pills' : 'tabs';
      }

      var containerProps = { id: id, className: className, style: style, activeKey: activeKey, onSelect: onSelect };

      var tabsProps = _extends({}, props, {
        bsStyle: bsStyle,
        bsClass: undefined,
        stacked: isHorizontal,
        ref: 'tabs',
        role: 'tablist'
      });

      var childTabs = _ValidComponentChildren2.default.map(children, this.renderTab);

      var panesProps = {
        ref: 'panes',
        animation: props.animation,
        unmountOnExit: props.unmountOnExit
      };

      var childPanes = children;

      if (isHorizontal) {
        (0, _deprecationWarning2.default)({
          message: 'Horizontal Tabs (position "left" or "right") are deprecated in favor ' + 'of the more flexible TabContainer component.'
        });

        if (!standalone) {
          containerProps.className = (0, _classnames2.default)(containerProps.className, 'clearfix');
        }

        var _getColProps = this.getColProps({ tabWidth: tabWidth, paneWidth: paneWidth }),
            tabsColProps = _getColProps.tabsColProps,
            panesColProps = _getColProps.panesColProps;

        var tabs = _react2.default.createElement(
          _Col2.default,
          _extends({ componentClass: _Nav2.default }, tabsProps, tabsColProps),
          childTabs
        );
        var panes = _react2.default.createElement(
          _Col2.default,
          _extends({ componentClass: _TabContent2.default }, panesProps, panesColProps),
          childPanes
        );

        if (position === 'left') {
          return _react2.default.createElement(
            TabContainer,
            containerProps,
            _react2.default.createElement(
              'div',
              null,
              tabs,
              panes
            )
          );
        }

        return _react2.default.createElement(
          TabContainer,
          containerProps,
          _react2.default.createElement(
            'div',
            null,
            panes,
            tabs
          )
        );
      }

      return _react2.default.createElement(
        TabContainer,
        containerProps,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _Nav2.default,
            tabsProps,
            childTabs
          ),
          _react2.default.createElement(
            _TabContent2.default,
            panesProps,
            childPanes
          )
        )
      );
    }
  }, {
    key: 'getActiveKey',
    value: function getActiveKey() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var activeKey = props.activeKey,
          children = props.children;

      return activeKey === undefined ? getDefaultActiveKeyFromChildren(children) : activeKey;
    }
  }, {
    key: 'renderPane',
    value: function renderPane(child, index) {
      return (0, _react.cloneElement)(child, {
        key: child.key ? child.key : index
      });
    }
  }, {
    key: 'renderTab',
    value: function renderTab(child) {
      if (child.props.title == null) {
        return null;
      }

      var _child$props = child.props,
          eventKey = _child$props.eventKey,
          title = _child$props.title,
          disabled = _child$props.disabled,
          tabClassName = _child$props.tabClassName;


      return _react2.default.createElement(
        _NavItem2.default,
        {
          eventKey: eventKey,
          disabled: disabled,
          className: tabClassName
        },
        title
      );
    }
  }, {
    key: 'getColProps',
    value: function getColProps(_ref) {
      var tabWidth = _ref.tabWidth,
          paneWidth = _ref.paneWidth;

      var tabsColProps = void 0;
      if (tabWidth instanceof Object) {
        tabsColProps = tabWidth;
      } else {
        tabsColProps = { xs: tabWidth };
      }

      var panesColProps = void 0;
      if (paneWidth == null) {
        panesColProps = {};
        Object.keys(tabsColProps).forEach(function (size) {
          panesColProps[size] = _styleMaps2.default.GRID_COLUMNS - tabsColProps[size];
        });
      } else if (paneWidth instanceof Object) {
        panesColProps = paneWidth;
      } else {
        panesColProps = { xs: paneWidth };
      }

      return { tabsColProps: tabsColProps, panesColProps: panesColProps };
    }
  }]);

  return Tabs;
}(_react2.default.Component);

Tabs.defaultProps = {
  bsClass: 'tab',
  animation: true,
  tabWidth: 2,
  position: 'top',
  standalone: false,
  unmountOnExit: false
};

Tabs.propTypes = {

  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: _propTypes2.default.any,

  /**
   * Navigation style for tabs
   *
   * If not specified, it will be treated as `'tabs'` when vertically
   * positioned and `'pills'` when horizontally positioned.
   */
  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),

  animation: _propTypes2.default.bool,

  onSelect: _propTypes2.default.func,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: _propTypes2.default.bool,

  /**
   * @deprecated Use TabContainer to create differently shaped tab layouts.
   */
  position: _propTypes2.default.oneOf(['top', 'left', 'right']),

  /**
   * Number of grid columns for the tabs if horizontally positioned
   *
   * This accepts either a single width or a mapping of size to width.
   *
   * @deprecated Use TabContainer to create differently shaped tab layouts.
   */
  tabWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  /**
   * Number of grid columns for the panes if horizontally positioned
   *
   * This accepts either a single width or a mapping of size to width. If not
   * specified, it will be treated as `styleMaps.GRID_COLUMNS` minus
   * `tabWidth`.
   *
   * @deprecated Use TabContainer to create differently shaped tab layouts.
   */
  paneWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  /**
   * Render without clearfix if horizontally positioned
   *
   * @deprecated Use TabContainer to create differently shaped tab layouts.
   */
  standalone: _propTypes2.default.bool
};

exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });